module.exports = __webpack_public_path__ + "img/blankscreen_100.29b1ecee.jpg";